module.exports = __webpack_public_path__ + "img/plan-1.e89b823f.png";